import React from 'react';
import { motion } from 'framer-motion';
type Language = 'ua' | 'en' | 'ru';
type MarqueeStripProps = {
  language?: Language;
};
const marqueeItems = {
  ua: ['Зроблено в Німеччині 🇩🇪', 'PRO-рішення для дистрибуції, роздрібної торгівлі та кузовних майстерень', 'Нам довіряють у понад 80 країнах світу', 'Міжнародна команда', '60+ років досвіду'],
  en: ['Made in Germany 🇩🇪', 'PRO solutions for distribution, retail, and body shops', 'Trusted in over 80 countries worldwide', 'International team', '60+ years of experience'],
  ru: ['Сделано в Германии 🇩🇪', 'PRO-решения для дистрибуции, розничной торговли и кузовных мастерских', 'Нам доверяют в более чем 80 странах мира', 'Международная команда', '60+ лет опыта']
};
export function MarqueeStrip({
  language = 'ru'
}: MarqueeStripProps) {
  // Use Russian as default since the prompt was in Russian, or map to the active language
  const items = marqueeItems[language] || marqueeItems.ru;
  // Duplicate items to ensure seamless infinite scroll
  const duplicatedItems = [...items, ...items, ...items, ...items];
  return <div className="w-full bg-chamaleon-yellow py-3 sm:py-4 overflow-hidden flex items-center border-y border-white/10" data-id="element-158">
      <motion.div className="flex whitespace-nowrap items-center" animate={{
      x: ['0%', '-50%']
    }} transition={{
      ease: 'linear',
      duration: 30,
      repeat: Infinity
    }} data-id="element-159">
        {duplicatedItems.map((item, index) => <div key={index} className="flex items-center" data-id="element-160">
            <span className="text-chamaleon-black font-heading font-bold text-sm sm:text-base md:text-lg uppercase tracking-wider px-6 sm:px-10" data-id="element-161">
              {item}
            </span>
            {/* Separator dot */}
            <span className="w-1.5 h-1.5 rounded-full bg-chamaleon-black/40" data-id="element-162" />
          </div>)}
      </motion.div>
    </div>;
}